export const calculateMainProductGpRequired = (
  avgCost,
  mainProductJaybelExcGstPrice,
) => {
  if (mainProductJaybelExcGstPrice === 0) return 0;
  const result = 100 - (avgCost * 100) / mainProductJaybelExcGstPrice;
  return parseFloat(result.toFixed(2));
};

// export const calculatemainProductJaybelExcGstPrice = (
//   avgCost,
//   mainProductGpRequired,
// ) => {
//   if (mainProductGpRequired === 100) return 0;
//   const result = (avgCost * 100) / (100 - mainProductGpRequired);
//   return parseFloat(result.toFixed(2));
// };

export const calculateMainProductCurrentSupplierGp = (
  mainProductCurrentSupplierExcGstPrice,
  avgCost,
) => {
  if (mainProductCurrentSupplierExcGstPrice === 0) return 0;
  const result =
    ((mainProductCurrentSupplierExcGstPrice - avgCost) /
      mainProductCurrentSupplierExcGstPrice) *
    100;
  return parseFloat(result.toFixed(2));
};

export const calculateMainProductSaving = (
  mainProductCurrentSupplierExcGstPrice,
  mainProductJaybelExcGstPriceTotal,
) => {
  if (mainProductCurrentSupplierExcGstPrice === 0) return 0;
  const result =
    ((mainProductCurrentSupplierExcGstPrice -
      mainProductJaybelExcGstPriceTotal) /
      mainProductCurrentSupplierExcGstPrice) *
    100;
  return parseFloat(result.toFixed(2));
};

export const calculateTotals = (
  mainProductQuantity,
  mainProductJaybelExcGstPrice,
  mainProductCurrentSupplierExcGstPrice,
) => {
  const mainProductJaybelExcGstPriceTotal =
    mainProductJaybelExcGstPrice * mainProductQuantity;
  const mainProductCurrentSupplierExcGstTotal =
    mainProductCurrentSupplierExcGstPrice * mainProductQuantity;
  const mainProductTotal =
    mainProductCurrentSupplierExcGstPrice * mainProductQuantity;
  return {
    mainProductJaybelExcGstPriceTotal: parseFloat(
      mainProductJaybelExcGstPriceTotal.toFixed(2),
    ),
    mainProductCurrentSupplierExcGstTotal: parseFloat(
      mainProductCurrentSupplierExcGstTotal.toFixed(2),
    ),
    mainProductTotal: parseFloat(mainProductTotal.toFixed(2)),
  };
};

export const calculateAlternateProductCurrentSupplierGp = (
  currentSupplierPrice,
  avgCost,
) => {
  if (!currentSupplierPrice || !avgCost) return 0;
  const result =
    ((currentSupplierPrice - avgCost) / currentSupplierPrice) * 100;
  return parseFloat(result.toFixed(2));
};

export const calculateAlternateProductSaving = (
  currentSupplierPrice,
  jaybelPrice,
) => {
  if (!currentSupplierPrice || !jaybelPrice) return 0;
  const result =
    ((currentSupplierPrice - jaybelPrice) / currentSupplierPrice) * 100;
  return parseFloat(result.toFixed(2));
};

export const calculateAlternateProductTotals = (
  alternateProductQuantity,
  jaybelPrice,
  currentSupplierPrice,
) => {
  const alternateProductJaybelExcGstPriceTotal =
    alternateProductQuantity * jaybelPrice;
  const alternateProductCurrentSupplierExcGstTotal =
    alternateProductQuantity * currentSupplierPrice;
  const alternateProductTotal = alternateProductQuantity * currentSupplierPrice;
  return {
    alternateProductJaybelExcGstPriceTotal: parseFloat(
      alternateProductJaybelExcGstPriceTotal.toFixed(2),
    ),
    alternateProductCurrentSupplierExcGstTotal: parseFloat(
      alternateProductCurrentSupplierExcGstTotal.toFixed(2),
    ),
    alternateProductTotal: parseFloat(alternateProductTotal.toFixed(2)),
  };
};

export const calculatemainProductCurrentSupplierIncGstPrice = (
  mainProductCurrentSupplierExcGstPrice,
) => {
  return parseFloat((mainProductCurrentSupplierExcGstPrice * 1.1).toFixed(2));
};

export const calculateMainProductJaybelIncGstPrice = (
  mainProductJaybelExcGstPrice,
) => {
  return parseFloat((mainProductJaybelExcGstPrice * 1.1).toFixed(2));
};

export const calculatemainProductJaybelExcGstPrice = (
  mainProductJaybelIncGstPrice,
) => {
  return parseFloat((mainProductJaybelIncGstPrice / 1.1).toFixed(2));
};

export const calculatemainProductCurrentSupplierExcGstPrice = (
  mainProductCurrentSupplierIncGstPrice,
) => {
  return parseFloat((mainProductCurrentSupplierIncGstPrice / 1.1).toFixed(2));
};

// Calculate Exclusive Jaybel Price if GP is given
export const calculateExclusiveJaybelPriceIfGpGiven = (avgCost, gpRequired) => {
  return parseFloat((avgCost / (1 - gpRequired / 100)).toFixed(2));
};

//Calculate GP if Jaybel price is given
export const calculateGpIfJaybelPriceGiven = (
  mainProductJaybelExcGstPrice,
  avgCost,
) => {
  return parseFloat(
    (
      ((mainProductJaybelExcGstPrice - avgCost) /
        mainProductJaybelExcGstPrice) *
      100
    ).toFixed(2),
  );
};

export const calculateAlternateProductJaybelExcGSTPrice = (
  alternateProductJaybelIncGstPrice,
) => {
  return parseFloat((alternateProductJaybelIncGstPrice / 1.1).toFixed(2));
};

export const calculateAlternateProductJaybelIncGSTPrice = (
  alternateProductJaybelExcGstPrice,
) => {
  return parseFloat((alternateProductJaybelExcGstPrice * 1.1).toFixed(2));
};
